import dayjs from "dayjs";
import { FALLBACK_DATE_FORMAT, FALLBACK_DATETIME_FORMAT, FALLBACK_TIME_FORMAT } from "~/utils/constants";
import { getRuntimeConfig } from "~/common/config/runtimeConfig";

export enum DateFormatType {
  DATE,
  DATETIME,
  TIME,
}

export function getPattern(type: DateFormatType) {
  function getDateFormat() {
    const { dateFormat } = getRuntimeConfig();
    if (dateFormat) {
      return dateFormat;
    }
    return FALLBACK_DATE_FORMAT;
  }
  function getDateTimeFormat() {
    const { datetimeFormat } = getRuntimeConfig();
    if (datetimeFormat) {
      return datetimeFormat;
    }
    return FALLBACK_DATETIME_FORMAT;
  }
  function getTimeFormat() {
    const { timeFormat } = getRuntimeConfig();
    if (timeFormat) {
      return timeFormat;
    }
    return FALLBACK_TIME_FORMAT;
  }
  function getJavaFormat(type: DateFormatType): string {
    switch (type) {
      case DateFormatType.DATE:
        return getDateFormat();
      case DateFormatType.DATETIME:
        return getDateTimeFormat();
      case DateFormatType.TIME:
        return getTimeFormat();
    }
  }
  function convertToDayjsFormat(format: string): string {
    return format.replaceAll("d", "D").replaceAll("y", "Y");
  }

  return convertToDayjsFormat(getJavaFormat(type));
}

function getGmt() {
  const rawOsset = getRuntimeConfig().timezoneOffset;
  const offset = (rawOsset / 60).toFixed(1);
  const sign = rawOsset >= 0 ? "+" : "-";
  return `(GMT${sign}${offset})`;
}

export function formatDate(date: Date, type: DateFormatType) {
  return dayjs(date).format(getPattern(type));
}

export function formatNullableDate(
  date: Date | undefined | null,
  type: DateFormatType,
  missingDateSymbol: string = "-",
) {
  if (!date) {
    return missingDateSymbol;
  }
  return formatDate(date, type);
}
